const drawSupportLine =  (res, tvWidget, s1, s2, s3, priceHistory) => {
  return new Promise((resolve, reject)=>{
    tvWidget?.onChartReady(() => {
     if (
       priceHistory[0]?.close < res.data[0]?.low ||
       priceHistory[0]?.close < res.data[1]?.low
     ) {
       for (let i = 2; i < res.data.length; i++) {
         if (priceHistory[0]?.close > res.data[i]?.low == true) {
           s3 =
             s3 ||
             tvWidget
               .activeChart()
               .createMultipointShape([{ price: res.data[i]?.low }], {
                 shape: "horizontal_line",
                 lock: true,
                 disableSelection: true,
                 disableSave: true,
                 disableUndo: true,
                 text: `S3@${res.data[i]?.low}`,
                 overrides: {
                   showLabel: true,
                   vertLabelsAlign: "bottom",
                   horzLabelsAlign: "right",
                   linecolor: "green",
                   showPrice: true,
                   textcolor: "green",
                   fontsize: 9,
                   linewidth: 1,
                 },
               });
           break;
         }
       }
     }
     s1 =
       s1 ||
       tvWidget
         .activeChart()
         .createMultipointShape([{ price: res.data?.[0]?.low }], {
           shape: "horizontal_line",
           lock: true,
           disableSelection: true,
           disableSave: true,
           disableUndo: true,
           // text: `S1@${res.data?.[0]?.low}`,
           text:
             priceHistory[0]?.close > res.data?.[0]?.low
               ? "S1@" + res.data?.[0]?.low
               : "S1->R1@" + res.data?.[0]?.low,
           overrides: {
             showLabel: true,
             vertLabelsAlign: "bottom",
             horzLabelsAlign: "right",
             textcolor:
               priceHistory[0]?.close > res.data?.[0]?.low
                 ? "green"
                 : "red",
             linecolor:
               priceHistory[0]?.close > res.data?.[0]?.low
                 ? "green"
                 : "red",
             showPrice: true,
             fontsize: 9,
             linewidth: 1,
           },
         });
     s2 =
       s2 ||
       tvWidget.activeChart().createMultipointShape(
         [
           {
             price: res.data?.[1]?.low,
           },
         ],
         {
           shape: "horizontal_line",
           lock: true,
           disableSelection: true,
           disableSave: true,
           disableUndo: true,
           // text: "S2@" + res.data?.[1]?.low,
           text:
             priceHistory[0]?.close > res.data?.[1]?.low
               ? "S2@" + res.data?.[1]?.low
               : "S2->R2@" + res.data?.[1]?.low,
           overrides: {
             showLabel: true,
             vertLabelsAlign: "bottom",
             horzLabelsAlign: "right",
             linecolor:
               priceHistory[0]?.close > res.data?.[1]?.low
                 ? "green"
                 : "red",
             textcolor:
               priceHistory[0]?.close > res.data?.[1]?.low
                 ? "green"
                 : "red",
             fontsize: 9,
             linewidth: 1,
           },
         }
       );
      });
      resolve({s1,s2,s3})
  })
};

export default () => {
  drawSupportLine;
  return {
    drawSupportLine
  }
};
